/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-10 17:27:55
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-15 17:10:32
 * @FilePath: /unifyxp-v2-store-portal/src/components/CollapseGroup/index.tsx
 */
import React from 'react';
import { DraggableProvided, DroppableId } from 'react-beautiful-dnd';

import { DragNDrop } from '@/src/components';
import { Collapse } from '@/src/components/Antd';

import styles from './style.module.less';

type Props = {
  droppableId: DroppableId;
  data: Array<Item>;
  openList: Array<string>;
  handleContainer?: JSX.Element;
  onSort: (newIndex: number, oldIndex: number) => void;
  onClickTitle?: (result: Array<string>) => void;
  disabled?: boolean;
};

type Item = Record<string, unknown> & {
  draggableId: string;
  title?: JSX.Element;
  titleGenerator?: (a: any) => JSX.Element;
  content?: JSX.Element;
  contentGenerator?: (a: any) => JSX.Element;
  style?: React.CSSProperties;
  open: boolean;
  errGenerate: (a: any) => JSX.Element;
};

function CollapseGroup({
  droppableId,
  data,
  openList = [],
  onSort,
  handleContainer,
  onClickTitle,
  disabled,
}: Props) {
  const handleClickTitle = (vis: boolean, draggableId) => {
    const result = vis ? [draggableId] : []; //只能打开一个情况下
    onClickTitle(result);
  };

  const renderChild = (
    item: Item,
    provided: DraggableProvided,
    index: number,
  ) => {
    const _err = () => {
      if (item.errGenerate) {
        return item.errGenerate(openList.indexOf(item.draggableId) !== -1);
      }
      return item.err || null;
    };
    const { titleGenerator, contentGenerator, content, title } = item;
    const commonProps = {
      data: item,
      provided,
      open: openList.indexOf(item.draggableId) !== -1,
    };
    const _title = titleGenerator ? titleGenerator(commonProps) : title;
    return (
      <div className={styles.collapseItem}>
        <Collapse
          titleStyle={item.style}
          id={item.draggableId}
          title={renderCollapseTitle(_title, provided)}
          content={contentGenerator ? contentGenerator(commonProps) : content}
          clickToExpand
          open={openList.indexOf(item.draggableId) !== -1}
          expandOffset={12}
          onClickTrigger={(vis: boolean) => {
            handleClickTitle(vis, item.draggableId);
          }}
          err={_err()}
        />
      </div>
    );
  };

  const renderCollapseTitle = (
    title: JSX.Element,
    provided: DraggableProvided,
  ) => (
    <div className={styles.title} {...provided.dragHandleProps}>
      <div>{handleContainer}</div>
      {title}
    </div>
  );

  return (
    <div className={styles.container}>
      <DragNDrop
        droppableId={droppableId}
        list={data}
        childGenerator={renderChild}
        onChange={onSort}
        disableAllDrags={disabled}
      />
    </div>
  );
}

export default CollapseGroup;
